<template>
    <div>
        <v-layout mb-4 wrap justify-space-between
                  :class="{'px-3': $vuetify.breakpoint.xs}"
        >
            <v-flex xs12 md6>
                <inputIcon v-model="search_organization" class="layout row search--no-border icon-clickable"
                           icon_name="search" :placeholder="$t('Введите название организации...')"
                           @icon:click="updateSearchInput(search_organization)"
                />
            </v-flex>
            <v-flex lg3 md4 sm6
                    justify-end d-flex :class="{'mt-4': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
            >
                <buttonBdWhite @click.native="TOGGLE_FILTER()">{{ showed_filter ? $t('Скрыть фильтр') : $t('Показать фильтр') }}</buttonBdWhite>
            </v-flex>
        </v-layout>
        <v-layout v-if="showed_filter" mb-4 wrap
                  align-center
                  justify-space-between :class="{'px-3': $vuetify.breakpoint.xs}"
        >
            <v-flex md3 sm5 xs12
                    class="mb-4"
            >
                <v-layout column>
                    <div class="grey-text mb-3">{{$t("Тип организации")}}</div>
                    <v-select
                        v-model="types_filtered"
                        :items="org_filters.types"
                        solo
                        append-icon=""
                        :label="$t('Выберите тип')"
                        class="input"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-select>
                </v-layout>
            </v-flex>
            <redLink class="pr-3" :class="{'flex xs12 mb-4': $vuetify.breakpoint.xs}" @click.prevent="reset_filters()">{{$t("Сбросить фильтр")}}</redLink>
        </v-layout>
        <dataTable :table="users_organizations_table" :search="search_organization" type="organizations" :filter="obj" />
        <v-layout align-center wrap :class="{'px-3 justify-center': $vuetify.breakpoint.xs, 'mt-4': $vuetify.breakpoint.smAndDown, 'mt-5 justify-end': $vuetify.breakpoint.mdAndUp}">
            <v-flex v-if="create_access"><buttonRed :class="{'flex   xs12 my-4': $vuetify.breakpoint.xs}" @click.native="OPEN_MODAL('add_organization')">{{$t("Добавить организацию")}}</buttonRed></v-flex>
            <v-flex md5 sm7 xs12>
                <div class="text-xs-center">
                    <v-pagination
                        v-model="pagination"
                        :length="org_pages"
                        :total-visible="$vuetify.breakpoint.xs ? 4 : 6"
                        prev-icon="arrow_back_ios"
                        next-icon="arrow_forward_ios"
                    />
                </div>
            </v-flex>
            <v-flex md4 sm6 xs12
                    :class="{'flex xs12': $vuetify.breakpoint.xs, 'mt-4': $vuetify.breakpoint.smAndDown}"
            >
                <v-select
                    v-model="tableSize"
                    :items="$vuetify.breakpoint.mdAndUp ? tableSizesBig : tableSizesSmall"
                    solo
                    append-icon=""
                    class="input"
                    @change="changeTableSize"
                >
                  <template #append>
                    <v-icon aria-hidden="true" translate="no">
                      expand_more
                    </v-icon>
                  </template>
                </v-select>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import inputIcon   from '@/components/ui/inputs/typed/input_icon';
import redLink from '@/components/ui/links/styled/link_red';
import dataTable from '../Users_table';
import buttonRed   from '@/components/ui/buttons/button_red';
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    dataTable,
    buttonRed,
    redLink,
    inputIcon,
    buttonBdWhite,
  },
  props: {
    create_access: {
      type: Boolean,
    },
  },
  data() {
    return {
      tableSizes: [
        {
          text: 'Показывать по 10',
          value: 10,
        },
        {
          text: 'Показывать по 25',
          value: 25,
        },
        {
          text: 'Показывать по 50',
          value: 50,
        },
        {
          text: 'Показывать по 100',
          value: 100,
        },
      ],
      tableSize: JSON.parse(localStorage.getItem('paginationValueOrganization')) || 10,
      obj: {
        page_size: JSON.parse(localStorage.getItem('paginationValueOrganization')) || 10,
        page_num : '',
        group    : '',
        spec     : '',
        llk      : '',
        name     : '',
      },
    };
  },
  computed: {
    tableSizesSmall() {
      return this.tableSizes
        .filter(({value}) => value != 100)
        .map(title => ({
          ...title,
          text: this.$t(title.text),
        }));
    },
    tableSizesBig() {
      return this.tableSizes
        .map(title => ({
          ...title,
          text: this.$t(title.text),
        }));
    },
    ...mapState('users/organizations', [
      'update_organizations',
    ]),
    ...mapGetters('users', [
      'tab',
      'showed_filter',
    ]),
    ...mapGetters('users/modals', [
      'add_user',
      'add_organization',
    ]),
    ...mapGetters('users/organizations', [
      'users_organizations_table',
      'org_filters',
      'group_filter',
      'type_filter',
      'department_filter',
      'org_pages',
      'page',
      'search_string',
    ]),
    search_organization: {
      get() {
        return this.search_string;
      },
      set($event) {
        return this.updateSearchInput($event.target.value);
      },
    },
    pagination: {
      get() {
        return this.page;
      },
      set($event) {
        this.SET_PAGE($event);
        this.obj.page_num = $event;
        this.get_companies(this.obj);
        return;
      },
    },
    groups_filtered: {
      get() {
        return this.group_filter;
      },
      set($event) {
        this.SET_GROUP_FILTER($event);
        this.obj.group = this.org_filters.groups.find((item)=>{
          return item.text == $event;
        }).id;
        this.get_companies(this.obj);
        return;
      },
    },
    types_filtered: {
      get() {
        return this.type_filter;
      },
      set($event) {
        this.SET_TYPE_FILTER($event);
        this.obj.spec = this.org_filters.types.find((item)=>{
          return item.text == $event;
        }).id;
        this.get_companies(this.obj);
        return;
      },
    },
    departments_filtered: {
      get() {
        return this.department_filter;
      },
      set($event) {
        this.SET_DEPARTMENT_FILTER($event);
        this.obj.llk = this.org_filters.departments.find((item)=>{
          return item.text == $event;
        }).id;
        this.get_companies(this.obj);
        return;
      },
    },
  },
  mounted() {
    this.update_table();
  },
  methods: {
    ...mapMutations('users', [
      'SET_ACTIVE_TAB',
      'TOGGLE_FILTER',
    ]),
    ...mapMutations('users/organizations', [
      'SET_PAGE',
      'SHOW_NUMBER',
      'SEARCH_ORGANIZATION',
      'SET_GROUP_FILTER',
      'SET_TYPE_FILTER',
      'SET_DEPARTMENT_FILTER',
      'RESET_ORG_FILTERES',
      'SET_UPDATE_ORGANIZATIONS',
    ]),
    ...mapMutations('users/modals', [
      'OPEN_MODAL',
      'CLOSE_MODAL',
    ]),
    ...mapActions('users/organizations', [
      'get_companies',
      'update_table',
    ]),
    updateSearchInput(value) {
      this.SEARCH_ORGANIZATION(value);
      this.obj.name = value;
      this.get_companies(this.obj);
    },
    reset_filters() {
      this.obj.group='';
      this.obj.spec ='';
      this.obj.llk ='';
      this.updateSearchInput('');
      this.get_companies(this.obj);
      this.RESET_ORG_FILTERES();
    },
    changeTableSize(nextSize) {
      try {
        localStorage.setItem('paginationValueOrganization', JSON.stringify(nextSize));
      } catch(e) {
        console.log('Could not save page size for organization pagination');
      }

      this.obj.page_size = nextSize;
      var tableSize = this.tableSizes.find(({value}) => value == nextSize);
      this.SHOW_NUMBER(tableSize && tableSize.text);
      this.get_companies(this.obj);
    }
  },
};
</script>
